import { FC } from 'react';

import { GiftSellerSidebar } from '@service/giftSeller/containers/GiftSellerSidebar/GiftSellerSidebar';
import { GiftChoiceUnitFormPage } from '@service/giftSeller/page/GiftChoiceUnitFormPage';
import { GiftChoiceUnitListPage } from '@service/giftSeller/page/GiftChoiceUnitListPage';
import { GiftCouponHistorySearchPage } from '@service/giftSeller/page/GiftCouponHistorySearchPage';
import { GiftCouponRedemptionListPage } from '@service/giftSeller/page/GiftCouponRedemptionListPage';
import { GiftCouponThemeFormPage } from '@service/giftSeller/page/GiftCouponThemeFormPage';
import { GiftCouponThemeListPage } from '@service/giftSeller/page/GiftCouponThemeListPage';
import { GiftDeliveryManagementPage } from '@service/giftSeller/page/GiftDeliveryManagementPage';
import { GiftEventLogPage } from '@service/giftSeller/page/GiftEventLogPage';
import { GiftItemBrandFormPage } from '@service/giftSeller/page/GiftItemBrandFormPage';
import { GiftItemBrandListPage } from '@service/giftSeller/page/GiftItemBrandListPage';
import { GiftItemFormPage } from '@service/giftSeller/page/GiftItemFormPage';
import { GiftItemInfoFormPage } from '@service/giftSeller/page/GiftItemInfoFormPage';
import { GiftItemInfoListPage } from '@service/giftSeller/page/GiftItemInfoListPage';
import { GiftItemListPage } from '@service/giftSeller/page/GiftItemListPage';
import { GiftOrderDashboardPage } from '@service/giftSeller/page/GiftOrderDashboardPage';
import { GiftOrderListPage } from '@service/giftSeller/page/GiftOrderListPage';
import { GiftOrderSearchPage } from '@service/giftSeller/page/GiftOrderSearchPage';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes } from 'react-router-dom';

const GiftSellerAuthRouter: FC = () => {
  const { isStoreSeller, isAdmin } = useAuth();

  const isSellerAuthenticated = isStoreSeller() || isAdmin();

  if (isSellerAuthenticated) {
    sessionStorage.removeItem('redirectUrlAfterGiftSellerLogin');
    return (
      <>
        <GiftSellerSidebar />
        <div className="min-h-screen lg:pl-64">
          <div className="flex flex-1 flex-col">
            <Routes>
              <Route path="" element={<GiftOrderListPage />} />
              <Route path="home" element={<GiftOrderListPage />} />
              <Route path="dashboard" element={<GiftOrderDashboardPage />} />
              {/* GiftOrder (주문 관리) */}
              <Route path="order-search" element={<GiftOrderSearchPage />} />
              {/* GiftCoupon (쿠폰 교환신청) */}
              <Route
                path="coupon-redemption"
                element={<GiftCouponRedemptionListPage />}
              />
              <Route path="coupon-history" element={<GiftCouponHistorySearchPage />} />
              {/* GiftDelivery (배송 관리) */}
              <Route
                path="delivery-management"
                element={<GiftDeliveryManagementPage />}
              />
              {/* GiftItemBrand (상품 브랜드) */}
              <Route path="item-brand" element={<GiftItemBrandListPage />} />
              <Route path="item-brand/new" element={<GiftItemBrandFormPage />} />
              <Route
                path="item-brand/:brandId/edit"
                element={<GiftItemBrandFormPage />}
              />
              {/* GiftChoiceUnit (선택유닛) */}
              <Route path="choice-unit" element={<GiftChoiceUnitListPage />} />
              <Route path="choice-unit/new" element={<GiftChoiceUnitFormPage />} />
              <Route
                path="choice-unit/:unitId/edit"
                element={<GiftChoiceUnitFormPage />}
              />
              {/* GiftCouponTheme (교환권 테마) */}
              <Route path="coupon-theme" element={<GiftCouponThemeListPage />} />
              <Route path="coupon-theme/new" element={<GiftCouponThemeFormPage />} />
              <Route
                path="coupon-theme/:themeId/edit"
                element={<GiftCouponThemeFormPage />}
              />
              {/* GiftItem (브랜드별 판매상품) */}
              <Route path="item" element={<GiftItemListPage />} />
              <Route path="item/new" element={<GiftItemFormPage />} />
              <Route path="item/:itemId/edit" element={<GiftItemFormPage />} />
              {/* GiftItemInfo (원상품) */}
              <Route path="item-info" element={<GiftItemInfoListPage />} />
              <Route path="item-info/new" element={<GiftItemInfoFormPage />} />
              <Route
                path="item-info/:itemInfoId/edit"
                element={<GiftItemInfoFormPage />}
              />
              {/* GiftEventLog (이벤트 로그) */}
              <Route path="event-log" element={<GiftEventLogPage />} />
              <Route path="*" element={<Navigate to="/gift-seller/home" />} />
            </Routes>
          </div>
        </div>
      </>
    );
  } else {
    return <Navigate to="/gift-seller/login" />;
  }
};

export default GiftSellerAuthRouter;
